import React from 'react';
import { Paragraph } from '../typography';
import HideAtDate from '../HideAtDate';

export default () => (
  <React.Fragment>
    <HideAtDate date="24/6/2023 16:00">
      <Paragraph red bold>
        Levering af fadølsanlæg og fadøl udsolgt onsdag den 21. juni til og med lørdag den 24. juni 2023.
      </Paragraph>
      { /*
        Vælg i stedet levering onsdag eller torsdag, det koster ikke ekstra eller &quot;henter selv&quot;, hvis du ønsker at bestille til denne dato.
      */ }
    </HideAtDate>
  </React.Fragment>
);
